<template src="./template.html"></template>
<style lang="scss" scoped src="./style.scss"></style>
<script>
export default {
    name: 'ak-page-list',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        }
    }
};
</script>
